import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, Alert } from 'reactstrap';
import ParticlesAuth from "../ParticlesAuth";


//import images
import logoLight from "../../../assets/images/crm-expert-logo-white.png";


const BasicSignIn = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [showPassword, setShowPassword] = useState(false);

    document.title = "Basic SignIn | Velzon - React Admin & Dashboard Template";

    const handleSubmit = (e) => {
        e.preventDefault();
        setError(null);
        const normalized = (email || '').trim().toLowerCase();

        // Check registered users from localStorage
        const users = JSON.parse(localStorage.getItem('velzonUsers') || '[]');
        if (!users || users.length === 0) {
            setError('No registered users found. Please sign up.');
            return;
        }

        const found = users.find((u) => u.email && u.email.toLowerCase() === normalized);
        if (found && found.password === password) {
            const userObj = { token: 'velzon-user-session', user: { email: found.email, name: found.first_name || '' } };
            sessionStorage.setItem('authUser', JSON.stringify(userObj));
            navigate('/portal/leads');
            return;
        }

        setError('Invalid username or password');
    };

    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="auth-page-content mt-lg-5">                
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center mt-sm-5 mb-4">
                                    <div className="d-inline-flex align-items-center justify-content-center bg-white rounded-3 p-3 shadow-sm">
                                        <img src={logoLight} alt="CRM Expert" height="42" />
                                    </div>
                                    <p className="mt-3 fs-15 fw-semibold text-muted">CRM Expert access for your sales and support teams.</p>
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="mt-4 shadow-lg border-0 rounded-4 overflow-hidden">
                                    <div className="p-4 bg-primary text-white text-center">
                                        <h5 className="mb-1 fw-semibold">CRM Expert Sign In</h5>
                                        <p className="mb-0 opacity-75">Welcome to the modern CRM dashboard experience.</p>
                                    </div>
                                    <CardBody className="p-4">
                                        <div className="text-center mt-2 mb-4">
                                            <h5 className="text-primary">Welcome Back!</h5>
                                            <p className="text-muted mb-0">Sign in to continue.</p>
                                            {error && <Alert color="danger" className="mt-3 mb-0">{error}</Alert>}
                                        </div>
                                        <div className="p-2 mt-4">
                                            <Form onSubmit={handleSubmit}>

                                                <div className="mb-3">
                                                    <Label htmlFor="username" className="form-label">Username or Email</Label>
                                                    <Input
                                                        id="username"
                                                        type="text"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        placeholder="Enter username or email"
                                                        className="form-control"
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <div className="float-end">
                                                        <Link to="/auth-pass-reset-basic" className="text-muted">Forgot password?</Link>
                                                    </div>
                                                    <Label className="form-label" htmlFor="password-input">Password</Label>
                                                    <div className="position-relative auth-pass-inputgroup mb-3">
                                                        <Input
                                                            id="password-input"
                                                            type={showPassword ? 'text' : 'password'}
                                                            value={password}
                                                            onChange={(e) => setPassword(e.target.value)}
                                                            placeholder="Enter password"
                                                            className="form-control pe-5"
                                                        />
                                                        <Button color="link" className="position-absolute end-0 top-0 text-decoration-none text-muted" type="button" onClick={() => setShowPassword(!showPassword)}>
                                                            <i className="ri-eye-fill align-middle"></i>
                                                        </Button>
                                                    </div>
                                                </div>

                                                <div className="form-check mb-4">
                                                    <Input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
                                                    <Label className="form-check-label" htmlFor="auth-remember-check">Remember me</Label>
                                                </div>

                                                <div className="mt-4">
                                                    <Button color="primary" className="w-100 py-2 fs-6" type="submit">Sign In</Button>
                                                </div>

                                                <div className="mt-4 text-center">
                                                    <p className="mb-0">Don't have an account ? <Link to="/auth-signup-basic" className="fw-semibold text-primary text-decoration-underline"> Signup </Link></p>
                                                </div>
                                            </Form>
                                        </div>
                                    </CardBody>
                                </Card>

                                <div className="mt-4 text-center">
                                    <p className="mb-0">Don't have an account ? <Link to="/auth-signup-basic" className="fw-semibold text-primary text-decoration-underline"> Signup </Link> </p>
                                </div>

                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default BasicSignIn;